// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const getSuppliersForSearchApi = () =>
  api().get('/data/supplier/index/search.json');

export default getSuppliersForSearchApi;
